const API_URL = process.env.REACT_APP_API_URL;

export const uploadVectorFile = async (file) => {
  if (!file) throw new Error('No file provided');

  const formData = new FormData();
  formData.append('file', file);
  const res = await fetch(`${API_URL}/vector-store/upload`, {    method: 'POST',
    body: formData,
  });

  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(`Upload failed: ${errorText}`);
  }

  return res.json();
};